import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import colors from "../../../Utils/colors";
import { MdArrowForwardIos } from "react-icons/md";
import { getPublishedWorkflowTemplate } from "../../../Services/index";
import { useNavigate } from "react-router-dom";
import { industriesData, workflowTemplates } from "../../../Utils/workflowLibraryUtils";
import images from "../../../Utils/images";
import SpinnerLoader from "../../../Components/SpinnerLoader"
import {eventsend} from "../../../Config/analyticsFunctions";
interface Industry {
  key: string;
  label: string;
  icon: string;
  selectedIcon: string;
}


interface ApiWorkflowTemplate {
  _id: string;
  name: string;
  description: string;
  tags?: string[];
  nodes?: { type: string }[];
}

interface WorkflowCardProps {
  title: string;
  description: string;
  source: string;
  sTitle: string;
  tags?: string[];
  templateId?: string | number;
}

const industries: Industry[] = [
  { key: 'Ecommerce', label: 'Ecommerce', icon: images.CART, selectedIcon: images.CARTBLUE },
  { key: 'Banking', label: 'Banking', icon: images.Banking, selectedIcon: images.BankBlue },
  { key: 'Education', label: 'Education', icon: images.Edu, selectedIcon: images.EduBlue },
  { key: 'Realestate', label: 'RealEstate', icon: images.Estate, selectedIcon: images.EstateBlue },
  { key: 'Healthcare', label: 'Healthcare', icon: images.Health, selectedIcon: images.HealthBlue },
  { key: 'Webinar', label: 'Webinar', icon: images.Web, selectedIcon: images.WebBlue },
];



const WorkflowCard: React.FC<WorkflowCardProps> = ({
  title,
  description = "",
  source,
  sTitle,
  tags = [],
  templateId,
}) => {
  const navigate = useNavigate();
  const localdata = useSelector((state: any) => state.main.localdata);
  const handleClick = () => {
    if (templateId) {
      eventsend('workflow_library_tab_viewed', {
        timestamp: new Date().toISOString(),
        account_id: localdata?.id,
        workflowTemplateName: title ?? "",
        creator_type: "System"
      })
      navigate(`../workflowLibrary/preview/${templateId}`);
    }
  }
 console.log(tags);

  return (
    <div
      style={{
        padding: '20px',
        borderRadius: '12px',
        backgroundColor: colors.white,
        border: `1px solid ${colors.grey2}`,
        cursor: 'pointer',
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between'
      }}
      onClick={handleClick}
    >
      <div>
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '10px' }}>
          <p style={{ fontWeight: 600 }}>{title ?? ""}</p>
          <MdArrowForwardIos height={2} />
        </div>
        <p style={{ fontSize: '14px', color: colors.darkgrey }}>{description ?? ""}</p>
      </div>

      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginTop: '15px' }}>
        <div style={{
          display: 'flex',
          alignItems: 'center',
          gap: '4px',
          padding: '4px 6px',
          borderRadius: '20px',
          border: `1px solid ${colors.greys03}`,
        }}>
          <img src={source} alt="" height={18} width={18} />
          <p style={{ fontSize: '12px', color: colors.black }}>{sTitle ?? ""}</p>
        </div>
        {/* <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
          {tags?.includes('email') && <img src={images.EmailWf} alt="Email" height={20} />}
          {tags?.includes('whatsapp') && <img src={images.WaWf} alt="WhatsApp" height={20} />}
          {tags?.includes('sms') && <img src={images.SMS} alt="SMS" height={20} />}
        </div> */}
      </div>
    </div>
  );
};

interface WorkflowLibraryProps {
  templateFilterText?: string;
}
type IndustryItem = {
  sTitle: string;
  source?: "";
  icon?: string;
};


type IndustriesDataMap = {
  incomingWA: IndustryItem[];
  incomingWebhook: IndustryItem[];
  facebookLead: IndustryItem[];
  shopify: IndustryItem[];
  campaign: IndustryItem[];
  pabblyEvent: IndustryItem[];
  instagramEvent: IndustryItem[];
  formsWFNode: IndustryItem[];
  contactWFNode: IndustryItem[];
  wooWFNode: IndustryItem[];
};

interface WorkflowTemplate {
  _id?: string;
  id?: string | number;
  title: string;
  description: string;
  source: string;
  sTitle: string;
  tags: string[];
  libMapName?: string;
  name?: string;
  category?: string;
}

const WorkflowLibrary: React.FC<WorkflowLibraryProps> = ({
  templateFilterText,
}) => {
  const [selectedTab, setSelectedTab] = useState<string>(() => {
    return localStorage.getItem("selectedcategory") || "Ecommerce";
  });
  const [allTemplates, setAllTemplates] = useState<ApiWorkflowTemplate[]>([]);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const authtoken = useSelector((state: any) => state.main.auth_token);
  useEffect(() => {
    getAllWfLibTemplatesList();
  }, [selectedTab]);
  useEffect(() => {
    localStorage.setItem("selectedcategory", selectedTab);
  }, [selectedTab]);

  const getAllWfLibTemplatesList = async () => {
    setIsLoading(true);
    const token = authtoken;
    try {
      const res = await getPublishedWorkflowTemplate(token, selectedTab);
      if (res?.flag) {
        setAllTemplates(res?.data ?? []);
        setIsLoading(false);
      }
      else {
        setAllTemplates([]);
      }
    } catch (err) {
      console.error("Error fetching templates", err);
      setAllTemplates([]);
    } finally {
      setIsLoading(false);
    }
  };

  const mergedTemplates: WorkflowTemplate[] = [
    ...(allTemplates ?? []).map((apiItem) => {
      type IndustryKey = keyof IndustriesDataMap;
      const typeKey = apiItem?.nodes?.[0]?.type as IndustryKey | undefined;
      const industry = typeKey ? industriesData?.[typeKey]?.[0] : undefined;

      return {
        _id: apiItem._id,
        title: apiItem.name ?? "",
        description: apiItem?.description ?? "",
        sTitle: industry?.sTitle ?? typeKey ?? "",
        tags: apiItem.tags ?? [],
        source: industry?.source ?? images.WAPPWF,
      };
    }),
    ...((workflowTemplates?.[selectedTab] as any[]) ?? []),
  ];



  if (selectedTab === "all") {
    const seenTitles = new Set<string>();
    workflowTemplates.all = Object.values(workflowTemplates ?? {})
      .filter((arr) => Array.isArray(arr))
      .flat()
      .filter(
        (t: any) => !!t?.title && !seenTitles.has(t.title) && seenTitles.add(t.title)
      );
  }
  const filteredTemplates = (mergedTemplates ?? []).filter((template) => {
    const title = template?.title ?? "";
    console.log("filteredTemplates",templateFilterText,title);
    return title.toLowerCase().startsWith((templateFilterText ?? "").toLowerCase());
  });

  const renderIndustryItem = (item: Industry) => {
    const isSelected = selectedTab === item.key;
    return (
      <div
        key={item.key}
        onClick={() => setSelectedTab(item.key)}
        style={{
          display: "flex",
          alignItems: "center",
          padding: "10px",
          cursor: "pointer",
          backgroundColor: isSelected ? "#F5F0FF" : colors.white,
          justifyContent: "flex-start",
          gap: "10px",
          borderRadius: "8px",
          color: isSelected ? colors.darkPurple : colors.black,
          marginTop: item.key !== "Ecommerce" ? "10px" : 0,
        }}
      >
        <img
          src={isSelected ? item.selectedIcon ?? "" : item.icon ?? ""}
          alt={item.label}
          height={25}
          width={25}
        />
        <p style={{ fontWeight: 500 }}>{item.label}</p>
      </div>
    );
  };

  return (
    <div
      style={{
        display: "flex",
        height: "calc(100vh - 100px)",
        overflow: "hidden",
        width: "100%",
      }}
    >
      <div
        style={{
          width: "20%",
          paddingTop: "10px",
          backgroundColor: colors.white,
          borderRight: `1px solid ${colors.greys03}`,
          height: "85vh",
          position: "sticky",
          top: 0,
          overflowY: "auto",
        }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            padding: "10px",
            justifyContent: "flex-start",
            gap: "10px",
            borderBottom: `1px solid ${colors.greys03}`,
            cursor: "pointer",
            color: selectedTab === "all" ? colors.darkPurple : colors.black,
            backgroundColor: selectedTab === "all" ? "#F5F0FF" : colors.white,
          }}
          onClick={() => setSelectedTab("all")}
        >
          <img
            src={images?.ALLWF}
            alt="All Templates"
            height={25}
            width={25}
            style={{ marginLeft: 5 }}
          />
          <p style={{ fontWeight: 500 }}>All Templates</p>
        </div>

        <div style={{ padding: "10px" }}>
          <p
            style={{
              fontWeight: 500,
              marginBottom: "10px",
              paddingLeft: "15px",
            }}
          >
            Industry
          </p>
          {industries?.map(renderIndustryItem)}
        </div>
      </div>

      <div
        style={{
          flex: 1,
          padding: "20px",
          overflowY: "auto",
          height: "85vh",
          position: "relative",
        }}
      >
        {isLoading && (
          <div
            style={{
              position: "absolute",
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              backgroundColor: "rgba(255,255,255,0.7)",
              zIndex: 10,
            }}
          >
            <SpinnerLoader />
          </div>
        )}

        {!isLoading && (
          filteredTemplates?.length > 0 ? (
            <div
              style={{
                display: "grid",
                gridTemplateColumns: "repeat(2, 1fr)",
                gap: "20px",
                gridAutoRows: "minmax(min-content, max-content)",
                alignContent: "start",
                marginBottom: "20px",
              }}
            >
              {filteredTemplates?.map((template, idx) => (
                <WorkflowCard
                  key={idx}
                  title={template?.title ?? ""}
                  description={template?.description ?? ""}
                  sTitle={template?.sTitle ?? ""}
                  tags={template?.tags ?? []}
                  templateId={template?._id ?? template?.id}
                  source={template?.source}
                />
              ))}
            </div>
          ) : (
            <div
              style={{
                flex: 1,
                display: "grid",
                gridTemplateColumns: "repeat(1, 1fr)",
                alignItems: "center",
                justifyContent: "center",
                height: "80vh",
              }}
            >
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <img
                  src={images?.EmptyWorkflows ?? ""}
                  alt="Empty workflow"
                  style={{
                    width: "100%",
                    maxWidth: "500px",
                    marginBottom: "20px",
                    objectFit: "contain",
                  }}
                />
                <p
                  style={{
                    fontSize: "16px",
                    fontWeight: 500,
                    color: colors.darkgrey,
                  }}
                >
                  No templates found
                </p>
              </div>
            </div>
          )
        )}
      </div>
    </div>
  );
};

export default WorkflowLibrary;